import React from 'react'
import { Box } from '@chakra-ui/react'
import VenueTable from './components/VenueTable'

export default function VenuesView() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <VenueTable />
    </Box>
  )
}
